<template>
    <div class="loading-wrapper">
        <div class="triangles">
            <div class="tri invert"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
            <div class="tri"></div>
            <div class="tri invert"></div>
        </div>
        <!-- <div id="floatBarsG">
            <div id="floatBarsG_1" class="floatBarsG"></div>
            <div id="floatBarsG_2" class="floatBarsG"></div>
            <div id="floatBarsG_3" class="floatBarsG"></div>
            <div id="floatBarsG_4" class="floatBarsG"></div>
            <div id="floatBarsG_5" class="floatBarsG"></div>
            <div id="floatBarsG_6" class="floatBarsG"></div>
            <div id="floatBarsG_7" class="floatBarsG"></div>
            <div id="floatBarsG_8" class="floatBarsG"></div>
        </div> -->
    </div>
    
</template>

<script>
    export default {
        name: "Loader"    
    }
</script>